import { Tag } from "../../models/tag";

export const sortTags = (tags: Tag[]) => {
  return [...tags].sort((a, b) => a.name.localeCompare(b.name)) ?? [];
};
